const sizeMap = {
  original: { width: 1280, height: 720, mode: "max" },
  square: { width: 250, height: 250, mode: "square" },
  thumbnail: { width: 320, height: 180, mode: "thumbnail" },
  medium: { width: 640, height: 360, mode: "fit" },
  large: { width: 1920, height: 1080, mode: "fit" },

  singlePropertyThumbnail: { width: 300, height: 180, mode: "min" },
  singlePropertyFirstImage: { width: 1260, height: 1032, mode: "fit" },
  singlePropertyImages: { width: 614, height: 500, mode: "fit" },
  singlePropertyGalleryLarge: { width: 600, height: 820, mode: "fit" },
  singlePropertyGallerySmall: { width: 600, height: 400, mode: "fit" },
};

function replaceImageUrlSize(templateUrl = null, size = null) {
  if (!templateUrl || !size) return templateUrl;

  const spec = sizeMap[size];
  if (!spec) return templateUrl;

  const { width, height, mode } = spec;
  // build the token in one line:
  // - for "square":   square250
  // - for thumbnail:  thumbnail320x180
  // - for medium/large (mode="fit"): fit640x360, fit1920x1080
  const transformToken = mode === "square" ? `square${width}` : `${mode}${width}x${height}`;

  return templateUrl.replace("{transform}", transformToken);
}

module.exports = replaceImageUrlSize;
